<template>
  <div
    class="field"
    :class="[
      {
        'field--active': active,
        'field--error': error
      },
      $props.class
    ]"
  >
    <slot name="input">
      <input
        class="field__input"
        :class="inputClass"
        v-bind="$attrs"
        v-model="model"
      >
    </slot>
    <slot name="suffix" />
  </div>
</template>

<script setup>
const model = defineModel({ type: String })

defineProps({
  active: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  },
  class: {
    type: String,
    default: ''
  },
  inputClass: {
    type: String,
    default: ''
  }
})

defineOptions({
  inheritAttrs: false
})
</script>

<style lang="less" scoped>
.field {
  display: flex;
  border: 1px solid #EBF1F5;
  border-radius: 4px;
  transition: border .2s;

  &:has(.field__input:focus) {
    border-width: 1.5px;
    border-color: #232323;
  }

  &--active {
    border-width: 1.5px;
    border-color: #232323;
  }

  &--error {
    border-width: 1.5px;
    border-color: #F53131;
  }

  &__input {
    padding: 12px;
    color: #232323;
    border: none;
    outline: none;
    width: 100%;
    font-family: mon-500;

    &::placeholder {
      color: #B2B7C2;
    }
  }
}
</style>
